import {FormattedMessage, useIntl} from "react-intl";
import {Modal, Box} from "@mui/material";

import React, {useState} from "react";
import SportIcon from "../../../components/SportIcon/SportIcon";
import GlobalConst from "../../../constants/GlobalConst";
import Currency from "../../../components/Currency/Currency";
import {useSelector} from "react-redux";
import {selectPartnerById, selectPrizeAssetById} from "../../../stores/pickX/pickX.selectors";
import _ from "lodash";

import "./WelcomePopUps.style.scss";

const PrizeAssetWelcomePopUp = ({id, title, subTitle, open, onClose, onCancel, onOk, options, data}) => {
    const {locale} = useIntl();

    const {preSelectedParlay} = data;

    const storageKey = "dontShowAgain_"+preSelectedParlay.Id;

    const prizeAsset = useSelector(state=>selectPrizeAssetById(state, preSelectedParlay.PrizeAssetId));
    const partner = useSelector(state=>selectPartnerById(state, prizeAsset.PartnerId));
    const league = GlobalConst.LEAGUES_BY_SPORT_ID[preSelectedParlay.SportIds[0]];
    const nbPicks = preSelectedParlay.ContestIds.length;
    const prizeAssetName = prizeAsset[`Name${_.capitalize(locale)}`] || "";

    const [dontShowAgain, setDontShowAgain] = useState(localStorage.getItem(storageKey) === "true");

    const onDontShowAgainChange = ()=>{
        const val = !dontShowAgain;
        setDontShowAgain(val);
        localStorage.setItem(storageKey, val.toString());
    }

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="PrizeAssetWelcomePopUp-title"
            aria-describedby="PrizeAssetWelcomePopUp-description"
            className={"WelcomePopUp PrizeAsset"}

        >
            <Box className="modal-box">


                <div className={"header " + league}>s
                    <button
                       className={"closeButton"}
                       onClick={onClose}>X</button>

                    <div className="name">
                        <SportIcon sportId={9} />
                        {league} PICK {nbPicks}
                    </div>

                    <div className={"prizeAssetName"}>
                        {/*<div className={"partnerName"}>{partner.Name || ""}</div>*/}
                        <div className="partnerLogo"
                             style={{backgroundImage: `url("data:image/png;base64,${partner?.Logo}")`}}>
                        </div>
                        <div className={"payout"}><Currency currency={prizeAsset.Currency}
                                                                value={prizeAsset.Value}
                                                                className={"gold-gradient-text"}
                                                                removeDecimal/></div>
                        <div className={"assetName gold-gradient-text"}>{prizeAssetName}</div>
                    </div>
                    <div className={"entryFee"}><FormattedMessage id={"popups.welcomePopUp.generic.entryFee"} />: <Currency currency={GlobalConst.SITE_CURRENCY} value={preSelectedParlay.Fee} removeDecimal/></div>

                </div>
                <div className="modal-content">

                    <ol>
                        <li><FormattedMessage id={"popups.welcomePopUp.generic.pickXOverOrUnder"}
                                              values={{nbPicks: <b>{nbPicks}</b>}} /></li>
                        <li><FormattedMessage id={"popups.welcomePopUp.generic.enterTheContest"} /></li>
                        <li>
                            <FormattedMessage id={"popups.welcomePopUp.prizeAsset.winGrandPrize"}
                                              values={{
                                                  nbPicks: <b>{nbPicks}</b>,
                                                  prizeAssetName: <b>{prizeAssetName}</b>
                                              }} />
                        </li>
                    </ol>

                    <button onClick={onOk}>
                        <FormattedMessage id={"popups.welcomePopUp.generic.makeYourPicks"} />
                    </button>
                    <div className="dontShowAgain checkbox white"
                         onClick={onDontShowAgainChange}>
                        <input type="checkbox"
                               id="dontShowAgain"
                               name="dontShowAgain"
                               checked={dontShowAgain}/>
                        <label htmlFor="term1">
                            <FormattedMessage id={"popups.welcomePopUp.generic.dontShowAgain"} />
                        </label>
                    </div>

                </div>
            </Box>
        </Modal>
    );
};

export default PrizeAssetWelcomePopUp;